import { Pencil } from '@phosphor-icons/react';
import HoursOfOperationWidget from '../../../../../signup/vendors/widgets/HoursOfOperationsWidget';
import { useUser } from '../../../../../../utils/UserContext';
import { Entity } from '../../../../../../types/apiTypes';

interface BusinessInformationProps {
  setBusinessEditPopupVisible: (visible: boolean) => void;
}

function BusinessInformation({
  setBusinessEditPopupVisible,
}: BusinessInformationProps) {
  const { userRecord } = useUser();
  return (
    <>
      {userRecord && userRecord?.userType === Entity.Vendor && (
        <div className="flex w-full flex-col gap-y-4 rounded-lg border-[1px] border-bordergray p-3 lg:w-[50%]">
          <div className="flex w-full flex-row justify-between align-middle">
            <h2 className="text-lg font-semibold">Business Information</h2>
            <Pencil
              className="text-accent hover:cursor-pointer"
              onClick={() => setBusinessEditPopupVisible(true)}
              size={24}
            />
          </div>
          <div className="flex flex-row gap-6">
            {/* Info Section */}
            <div className={`grid w-full grid-cols-1 gap-1`}>
              {/* VIN Number */}
              <div className="flex flex-row items-center gap-x-2 bg-primarybg px-2 py-[2px] align-middle">
                <p className="w-[35%] min-w-[35%] text-[14px] text-[#858897]">
                  Business Name
                </p>
                <p className="text-[14px] text-primary">
                  {userRecord?.business_name}
                </p>
              </div>
              <div className="flex flex-row items-center gap-x-2 px-2 py-[2px] align-middle">
                <p className="w-[35%] min-w-[35%] text-[14px] text-[#858897]">
                  First Location Business Address
                </p>
                <p className="text-[14px] text-primary">
                  {userRecord?.address_st_number +
                    ' ' +
                    userRecord?.address_st_name +
                    ' ' +
                    (userRecord?.address_unit?.length
                      ? userRecord?.address_unit
                      : '') +
                    ', ' +
                    userRecord?.address_city +
                    ', ' +
                    userRecord?.address_state +
                    ' ' +
                    userRecord?.address_zip}
                </p>
              </div>
              <div
                className={`flex flex-row items-center gap-x-2 bg-primarybg px-2 py-[2px] align-middle`}
              >
                <p className="w-[35%] min-w-[35%] text-[14px] text-[#858897]">
                  Business Phone Number
                </p>
                <p className="text-[14px] text-primary">
                  {userRecord?.business_phone_number}
                </p>
              </div>
              <div
                className={`flex flex-row items-center gap-x-2 px-2 py-[2px] align-middle`}
              >
                <p className="w-[35%] min-w-[35%] text-[14px] text-[#858897]">
                  Business Email
                </p>
                <p className="text-[14px] text-primary">{userRecord?.email}</p>
              </div>
              <div
                className={`flex flex-row items-center gap-x-2 bg-primarybg px-2 py-[2px] align-middle`}
              >
                <p className="w-[35%] min-w-[35%] text-[14px] text-[#858897]">
                  Website URL
                </p>
                <p className="text-[14px] text-primary">
                  {userRecord?.website_url}
                </p>
              </div>
              <div
                className={`flex flex-row items-center gap-x-2 px-2 py-[2px] align-middle`}
              >
                <p className="w-[35%] min-w-[35%] text-[14px] text-[#858897]">
                  Description of Services
                </p>
                <p className="text-[14px] text-primary">
                  {userRecord?.description_of_services}
                </p>
              </div>
              <HoursOfOperationWidget
                hoursOfOperation={JSON.parse(
                  userRecord?.hours_of_operation ?? ''
                )}
                viewOnly={true}
                addClass="mt-4"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BusinessInformation;
